import { render, staticRenderFns } from "./PriceInput.vue?vue&type=template&id=6a6aeaa2&"
import script from "./PriceInput.vue?vue&type=script&lang=js&"
export * from "./PriceInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports